// Google Analytics Event Tracking
export const analytics = {
  // Page view tracking
  logPageView(path) {
    if (window.gtag) {
      window.gtag('config', 'G-RR3G3D7WJZ', {
        page_path: path
      });
    }
  },

  // Event tracking
  logEvent(eventName, params = {}) {
    if (window.gtag) {
      window.gtag('event', eventName, params);
    }
  },

  // User properties
  setUserProperties(properties = {}) {
    if (window.gtag) {
      window.gtag('set', 'user_properties', properties);
    }
  }
}; 